import React from 'react';
import PropTypes from 'prop-types';
import './ProposalGenerator/ProposalBox.css';

const getPriceForProduct = (product, priceKey) => {
  if (!product) {
    return null;
  }
  return product.price;
};

const getNetPrice = (price, quantity) => {
  return (price * quantity).toFixed(2);
};

const sortCount = box => {
  let arr = [];
  Object.values(box).map(prod =>
    prod.products.map(item => {
      if (item.selected) {
        arr.push(item);
      }
    }),
  );
  function byField(field) {
    return (a, b) => (a[field] > b[field] ? 1 : -1);
  }
  return arr.sort(byField('count'));
};

const ProposalBoxOTCView = ({ box, priceKey, boxTotal, getInstallationSum }) => {
  const { oneTimeCharge, installation } = box;
  return (
    <>
      {sortCount(oneTimeCharge).map(prod => {
        const productPrice = getPriceForProduct(prod, priceKey);
        if (!productPrice) {
          return null;
        }
        return (
          <tr key={prod.name}>
            <td style={{ textAlign: 'left' }} className="productDescriptonCell">
              {prod.description}
            </td>
            <td style={{ textAlign: 'right' }}>{`$ ${prod.price}`}</td>
            <td style={{ textAlign: 'center' }}>{prod.quantity}</td>
            <td>{`$ ${getNetPrice(prod.price, prod.quantity)}`}</td>
          </tr>
        );
      })}
      {sortCount(installation).map(prod => {
        const productPrice = getPriceForProduct(prod, priceKey);
        if (!productPrice) {
          return null;
        }
        return (
          <tr key={prod.name}>
            <td style={{ textAlign: 'left' }} className="productDescriptonCell">
              {prod.description}
            </td>
            <td style={{ textAlign: 'right' }}>{`$ ${prod.price}`}</td>
            <td style={{ textAlign: 'center' }}>{prod.quantity}</td>
            <td>{`$ ${getNetPrice(prod.price, prod.quantity)}`}</td>
          </tr>
        );
      })}

      <tr className="emptyTr row-mb-not">
        <td colSpan="3" style={{ textAlign: 'right' }}>
          Appliance Net Price:
        </td>
        <td style={{ textAlign: 'right' }} className="viewRowBlueColor">{`$${(
          boxTotal + getInstallationSum
        ).toFixed(2)}`}</td>
      </tr>
      <tr className="emptyTr">
        <td colSpan="3">
          Taxes not included. One-time Charges are non-refundable, billed and collected separately
          by EPIK for services rendered regardless if or when this agreement commences. Remit to:
          EPIK, Attn: Finance, 24800 Chrisanta Drive, Suite 230, Mission Viejo, CA 92691
        </td>
        <td />
      </tr>
    </>
  );
};

ProposalBoxOTCView.propTypes = {
  boxName: PropTypes.string,
  boxTotal: PropTypes.number,
  box: PropTypes.shape({
    boxId: PropTypes.string,
    boxName: PropTypes.string,
    quantity: PropTypes.number,
    oneTimeCharge: PropTypes.oneOfType([
      PropTypes.arrayOf(
        PropTypes.shape({
          _id: PropTypes.string,
          name: PropTypes.string,
          multiSelect: PropTypes.bool,
          deleted: PropTypes.bool,
          enabled: PropTypes.bool,
          products: PropTypes.arrayOf(
            PropTypes.shape({
              name: PropTypes.string,
              description: PropTypes.string,
              priceList: PropTypes.arrayOf(
                PropTypes.shape({
                  key: PropTypes.string,
                  desc: PropTypes.string,
                  price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                }),
              ),
              selected: PropTypes.bool,
              quantity: PropTypes.number,
            }),
          ),
        }),
      ),
      PropTypes.objectOf(
        PropTypes.shape({
          _id: PropTypes.string,
          name: PropTypes.string,
          multiSelect: PropTypes.bool,
          deleted: PropTypes.bool,
          enabled: PropTypes.bool,
          products: PropTypes.arrayOf(
            PropTypes.shape({
              name: PropTypes.string,
              description: PropTypes.string,
              priceList: PropTypes.arrayOf(
                PropTypes.shape({
                  key: PropTypes.string,
                  desc: PropTypes.string,
                  price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
                }),
              ),
              selected: PropTypes.bool,
              quantity: PropTypes.number,
            }),
          ),
        }),
      ),
    ]),
  }).isRequired,
  oneTimeCharge: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string,
      groupName: PropTypes.string,
      multiSelect: PropTypes.bool,
      deleted: PropTypes.bool,
      company: PropTypes.string,
      products: PropTypes.arrayOf(
        PropTypes.shape({
          name: PropTypes.string,
          description: PropTypes.string,
          priceList: PropTypes.arrayOf(
            PropTypes.shape({
              desc: PropTypes.string,
              price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
              key: PropTypes.string,
            }),
          ),
        }),
      ),
    }),
  ),
  priceKey: PropTypes.string.isRequired,
};

ProposalBoxOTCView.defaultProps = {
  boxName: '',
  oneTimeCharge: {},
  boxTotal: 0,
};

export default ProposalBoxOTCView;
